export default __webpack_public_path__ + "static/testimonials-95ae5dcba0ed1a9b2b190dcca0af9a3c.png";